export class SmsRequestModel
{
    messages: MessageRequetModel[];
    default: DefaultRequestModel;
}

export class MessageRequetModel
{
    to: string;
    body: string;
}

export class DefaultRequestModel
{
    body: string;
    normalize: boolean;
}